import useCaseApi from '@repo/editor/src/api/useCases';
import { TransformedUseCase } from '@repo/editor/src/types';

export const revalidateUseCaseKey = 'UseCaseRevalidationKey';

export async function getUseCaseData(): Promise<TransformedUseCase[]> {
  const useCaseResponse = await useCaseApi.getUseCases({
    next: { revalidate: 24 * 60 * 60, tags: [revalidateUseCaseKey] }, //every day
  });
  const allUseCases = useCaseResponse.success ? useCaseResponse.categories : [];
  return allUseCases;
}
